import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ComponentFactoryResolver, ViewEncapsulation, QueryList, ViewChildren, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IFormOptions, IFieldOptions, ITabOptions } from '@framework/interfaces/IEntity';
import { ApiService } from '@services/api/api.service';
import { IEntityModel, IEntityModelField } from '@framework/interfaces/IEntityModel';
import { FormBuilderControl } from '@common/formbuilder/FormBuilderControl';
import { FormBuilderControlType } from '@common/formbuilder/FormBuilderControlType';
import { Subscription } from '../../../../../node_modules/rxjs';
import { MenuItem } from '../../../../../node_modules/primeng/components/common/menuitem';
import { ViewType } from '@framework/core/Enums';
import { ListPageComponent } from '@framework/components/mf-list-page/mf-list-page.component';
import { NbToastrService } from '@nebular/theme';
import { PermissionListComponent } from '@modules/hr/components/permission-list/permission-list.component';
import { DirectoryRolePermissionsComponent } from '@modules/hr/components/directory-role-permissions/directory-role-permissions.component';
import { MfBladeComponent } from '../mf-blade/mf-blade.component';

export interface IDetailPageComponentTab {
  displayName: string;
  tab: any;
  isHidden?: boolean;
}

@Component({
  selector: 'mf-form-page',
  templateUrl: './mf-form-page.component.html',
  styleUrls: ['./mf-form-page.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DetailsPageComponent implements OnInit, OnDestroy {
  @ViewChild('tabDetail', { static: true }) tabDetail: ViewContainerRef;
  @ViewChildren('tabDetails', { read: ViewContainerRef }) public tabDetails: QueryList<ViewContainerRef>;
  protected detailPageComponentForm: IFormOptions;
  protected detailPageComponentTabs: Array<IDetailPageComponentTab>;
  private _subscriptions: Array<Subscription> = new Array<Subscription>();
  private _newItem: boolean = false;
  protected _entityId: any;
  private tabInstances: any;
  public formFields: Array<FormBuilderControl>;
  public tabViews: Array<any>;
  public get form(): IFormOptions { return this.detailPageComponentForm };
  public get tabs(): Array<IDetailPageComponentTab> { return this.detailPageComponentTabs };
  public get newItem(): boolean { return this._newItem };
  public entityData: any = {};
  public loading: boolean = false;
  public hidden: boolean = false;
  public get entityId() { return this._entityId };
  public set entityId(value) {
    if (this._entityId == value)
      return;
    this._entityId = value; this.loadEntity();
  }
  public parent: any;
  public get header(): string { return this.entityData && this.form.displayName ? this.entityData[this.form.displayName] : null };
  public activeIndex: number = 0;
  protected loadWithoutParams: boolean = false;

  constructor(private apiService?: ApiService, private route?: ActivatedRoute, private componentFactoryResolver?: ComponentFactoryResolver,
    private messageService?: NbToastrService) { }

  private getFormBuilderControls(entityModelFields: Array<IFieldOptions>): Array<FormBuilderControl> {
    return entityModelFields.map(item => {
      let control = new FormBuilderControl();
      let itemDTO: IEntityModelField = this.form.model.fields[item.field];
      control.controlType = new FormBuilderControlType(typeof item.fieldType != undefined ? item.fieldType : itemDTO.fieldType, null);
      
      control.displayName = item.name ? item.name : itemDTO.displayName;
      control.bindingValue = item.field;
      control.field = item.field;
      control.show = function (scope) {
        if (item.show) return item.show(scope);
        return true;
      };
      if (item.viewType) {
        control.controlType.viewType = item.viewType;
      }
      if (item.lookups) {
        control.lookups = item.lookups;
      }
      
      control.fieldOptions = item;

      return control;
    });
  }
  private buildTabs() {
    this.tabInstances = new Array();
    for (let i = 0; i < this.tabDetails.toArray().length; i++) {
      let component = this.detailPageComponentTabs[i];
      if (component) {
        let target = this.tabDetails.toArray()[i];
        let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(component.tab);
        let componentRef: any = target.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.entity = component.tab;
        _component.entity.component = _component;
        _component.parent = this;
        this.tabInstances.push(_component);
        if (_component instanceof PermissionListComponent)
          _component.permissionsUpdatedObserver.subscribe(permissionIdList => {
            var tabIndex = 0;
            this.detailPageComponentTabs.forEach(comp => {
              tabIndex++
              if (comp.displayName == "EMS Directories")
                if (permissionIdList.indexOf("3C004A94-15CE-4473-9971-7897FC3742D0".toLowerCase()) != -1 || permissionIdList.indexOf("A8A5A5E6-037F-4E4C-9B96-9D5C08355F8F".toLowerCase()) != -1) {
                      comp.isHidden = false;
                }
                else {
                  comp.isHidden = true;
                  if (this.activeIndex == tabIndex)
                    this.activeIndex -= 1;
                }
              
            })

          })
      }
    }
  }

  public ngOnInit() {
    if (this.loadWithoutParams)
      this.entityId = "0";
    this.formFields = this.getFormBuilderControls(this.detailPageComponentForm.fields);
    this._subscriptions.push(
      this.route.params.subscribe(params => {
        this.entityId = params['id'];
      })
    );
    if (this.parent && typeof this.parent.entityIdChange) {
      debugger;
      this.parent.entityIdChange.subscribe(entityId => {
        this._entityId = entityId;
      })
    }
  }

  public ngAfterViewInit() {
    if (this.detailPageComponentTabs && this.detailPageComponentTabs.length > 0) {
      this.buildTabs();
    }
  }

  public ngOnDestroy() {
    while (this._subscriptions.length > 0) this._subscriptions.pop().unsubscribe();
  }

  public loadEntity() {

    let self: DetailsPageComponent = this;
    if (!self.entityId || self.newItem) return;
    self.loading = true;
    if (self.form.dataEndPoint)
      self.apiService.exec({
        endPoint: self.form.dataEndPoint,
        context: self,
        success: function (data) {
          self.entityData = self._newItem ? {} : data;
          self.loading = false;
        },
        error: function (error) {
          self.loading = false;
          self.messageService.danger('error', 'Could not load');
        }
      })
  }
  public addNew() {
    this._newItem = true;
    this.entityData = {};
  }
  public save() {
    let self: DetailsPageComponent = this;
    self.loading = true;
    if (self.form.endPoints && self.form.endPoints.update)
      self.apiService.exec({
        endPoint: self.form.endPoints.update,
        data: self.entityData,
        context: self,
        success: function (data) {
          self.loading = false;
          if (self.parent && self.parent.loadData)
            self.parent.loadData();
          self.messageService.success('Saved successfully', 'Action');
        }, error: function (error) {
          self.loading = false;
          self.messageService.danger((error && error.error ? error.error : ''), 'Could not save');
        }
      });
      
  }
  public saveNew(close: Function) {
    let self: DetailsPageComponent = this;
    self.loading = true;
    if (self.form.endPoints && self.form.endPoints.insert)
      self.apiService.exec({
        endPoint: self.form.endPoints.insert,
        data: self.entityData,
        context: self,
        success: function (item) {
          close(item);
          self.loading = false;
          self.messageService.success('Saved successfully', 'Action');
        }, error: function (error) {
          self.loading = false;

          self.messageService.danger((error && error.error ? error.error : ''), 'Could not save. ');
        }
    });
  }

  public updateLists() {
   


  }
}
